export default "__VITE_ASSET__BPFOLb2M__"